export default "__VITE_ASSET__CzY36oek__"